module.exports = __webpack_public_path__ + "static/media/02_bengal_tiger.63380ab6.png";